<script>
export default {
  components: {},
  props: {
    title: {
      type: String,
      default: "",
    },
    items: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },
};
</script>

<template>
  <!-- start page title -->
  <div class="row">
    <div class="col-12">
      <div class="d-flex align-items-center justify-content-between mb-2">
        <h4 class="mb-0 responsive-title">{{ title }}</h4>

        <div class="page-title-right ">
          <b-breadcrumb :items="items" class="m-0 responsive-breadcrumb"></b-breadcrumb>
        </div>
      </div>
    </div>
  </div>
  <!-- end page title -->
</template>

<style>
  @media (max-width: 576px) { /* Extra small devices (phones) */
    .responsive-title {
      font-size: 0.9rem; /* Small font size */
    }
  }
  @media (min-width: 577px) and (max-width: 768px) { /* Small devices (tablets) */
    .responsive-title {
      font-size: 1.05rem; /* Slightly larger font size */
    }
  }
  @media (min-width: 769px) { /* Medium and larger devices (desktops) */
    .responsive-title {
      font-size: 1.2rem; /* Larger font size */
    }
  }
  @media (max-width: 576px) { /* Extra small devices (phones) */
    .responsive-breadcrumb {
      font-size: 0.8rem; /* Small font size */
    }
  }
  @media (min-width: 577px) and (max-width: 768px) { /* Small devices (tablets) */
    .responsive-breadcrumb {
      font-size: 0.9rem; /* Slightly larger font size */
    }
  }
  @media (min-width: 769px) { /* Medium and larger devices (desktops) */
    .responsive-breadcrumb {
      font-size: 1rem; /* Larger font size */
    }
  }
</style>
